import React from 'react';

const WhyChooseUs = () => {
  return (
    <section className="px-8 py-20 text-gray-800 bg-white">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="mb-6 text-4xl font-bold">Why Choose Blessed Montessori?</h2>
        <p className="mb-12 text-lg text-gray-600">
          Empowering young minds to become confident, compassionate, and capable global citizens.
        </p>
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {/* Card 1 */}
          <div className="p-6 transition shadow-md bg-gradient-to-tr from-purple-100 to-blue-100 rounded-xl hover:shadow-xl">
            <h3 className="mb-3 text-2xl font-semibold text-blue-700">Global Curriculum</h3>
            <p className="text-sm text-gray-600">
              We offer internationally aligned academic programs, blending excellence with innovation.
            </p>
          </div>
          {/* Card 2 */}
          <div className="p-6 transition shadow-md bg-gradient-to-tr from-blue-100 to-green-100 rounded-xl hover:shadow-xl">
            <h3 className="mb-3 text-2xl font-semibold text-green-700">World-Class Facilities</h3>
            <p className="text-sm text-gray-600">
              Our campus is equipped with modern labs, libraries, and digital classrooms for optimal learning.
            </p>
          </div>
          {/* Card 3 */}
          <div className="p-6 transition shadow-md bg-gradient-to-tr from-green-100 to-purple-100 rounded-xl hover:shadow-xl">
            <h3 className="mb-3 text-2xl font-semibold text-purple-700">Holistic Development</h3>
            <p className="text-sm text-gray-600">
              We nurture every child academically, emotionally, and socially through clubs, arts, and sports.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
